@if (configuracion) {
  <form [formGroup]="formulario">
    <div
      formArrayName="campos"
      class="campos"
      [ngClass]="obtenerClases('campos')"
      *ngVar="configuracion.estilo || {} as estilo"
      [style.--width-campo]="estilo?.widthCampo || '200px'"
      [style.--width-label]="estilo?.widthLabel || '200px'"
    >
      @for (campo of configuracion.campos; track campo; let i = $index) {
        <div
          [ngClass]="obtenerClases('campo')"
          class="campo {{ 'campo-' + campo.slug }} {{ 'campo-tipo-' + campo.tipo }}"
          [class.oculto]="campo.oculto"
        >
          <!-- Label -->
          @if (
            mostrarLabel(PosicionLabelFormulario.TOP) ||
            mostrarLabel(PosicionLabelFormulario.IZQUIERDA)
          ) {
            <span class="label" [class.bold]="configuracion.estilo?.labelNegrilla">
              {{ campo.nombre }}
              {{ campo.requerido && estilo?.marcarRequeridos ? ' *' : '' }}
              {{ !campo.requerido && estilo?.marcarOpcionales ? ' (Opcional)' : '' }}
              @if (campo.info) {
                <mat-icon [matTooltip]="campo.info" inline class="info-icon" color="primary">
                  info
                </mat-icon>
              }
            </span>
          }
          <div class="cont-input">
            <!-- Form Field -->
            <mat-form-field
              [class.readonly]="
                campo.readonly &&
                (campo.tipo === TipoCampoFormulario.OPCION_MULTIPLE ||
                  campo.tipo === TipoCampoFormulario.BOOLEANO ||
                  campos.controls[i].value === null)
              "
              [class.mat-mdc-form-field-has-icon-suffix]="
                campo.tipo === TipoCampoFormulario.FECHA ||
                campo.tipo === TipoCampoFormulario.ARCHIVO ||
                (campo.tipo === TipoCampoFormulario.TEXTO && campo.url)
              "
              appearance="outline"
              [hideRequiredMarker]="true"
              [class.multilinea]="campo.tipo === TipoCampoFormulario.TEXTO && campo.multilinea"
            >
              @if (mostrarLabel(PosicionLabelFormulario.DENTRO)) {
                <mat-label>
                  {{ campo.nombre }}
                  {{ campo.requerido && estilo?.marcarRequeridos ? ' *' : '' }}
                  {{ !campo.requerido && estilo?.marcarOpcionales ? ' (Opcional)' : '' }}
                  @if (campo.info) {
                    <mat-icon [matTooltip]="campo.info" inline class="info-icon" color="primary">
                      info
                    </mat-icon>
                  }
                </mat-label>
              }
              <!-- Campo: Texto -->
              @if (campo.tipo === TipoCampoFormulario.TEXTO) {
                @if (campo.multilinea) {
                  <textarea
                    matInput
                    [placeholder]="campo.placeholder ?? ''"
                    [formControlName]="i"
                    [readonly]="campo.readonly || false"
                    [minlength]="campo.longitudMinima || null"
                    [rows]="campo.filas || 4"
                  ></textarea>
                } @else {
                  <input
                    matInput
                    [placeholder]="campo.placeholder ?? ''"
                    [formControlName]="i"
                    [readonly]="campo.readonly || false"
                    [minlength]="campo.longitudMinima || null"
                    [pattern]="campo.patron || ''"
                    type="{{ campo.contrasena ? 'password' : campo.correo ? 'email' : 'text' }}"
                  />
                }
                @if (campo.readonly && campo.url && campo.valor) {
                  <button matSuffix mat-icon-button (click)="abrirUrl(campo.valor)">
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                }
              }
              <!-- Campo: Número -->
              @if (campo.tipo === TipoCampoFormulario.NUMERO) {
                @if (campo.prefijo) {
                  <span matTextPrefix>{{ campo.prefijo }}</span>
                }
                <input
                  matInput
                  [type]="campo.telefono ? 'tel' : campo.separadorMiles ? 'text' : 'number'"
                  (wheel)="$event.preventDefault()"
                  [placeholder]="campo.placeholder ?? ''"
                  [formControlName]="i"
                  [min]="campo.separadorMiles ? null : campo.minimo || null"
                  [max]="campo.separadorMiles ? null : campo.maximo || null"
                  [minlength]="campo.longitudMinima || null"
                  [pattern]="
                    campo.decimal
                      ? '^-?[0-9]*[.]?[0-9]*$'
                      : campo.telefono
                        ? '^[0-9]*$'
                        : campo.separadorMiles
                          ? '^[0-9.]*$'
                          : '^-?[0-9]*$'
                  "
                  (blur)="campo.separadorMiles ? onBlurMiles($event) : null"
                  (focus)="campo.separadorMiles ? onFocusMiles($event) : null"
                  [readonly]="campo.readonly || false"
                />
                @if (campo.sufijo) {
                  <span matTextSuffix>{{ campo.sufijo }}</span>
                }
              }
              <!-- Campo: Fecha -->
              @if (campo.tipo === TipoCampoFormulario.FECHA) {
                <input
                  matInput
                  [matDatepicker]="picker"
                  [placeholder]="campo.placeholder ?? ''"
                  [formControlName]="i"
                  [min]="campo.minimo || null"
                  [max]="campo.maximo || null"
                  [readonly]="campo.readonly || false"
                />
                @if (!campo.readonly && !campo.disabled && !campos.controls[i].value) {
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                }
                @if (!campo.readonly && !campo.disabled && !!campos.controls[i].value) {
                  <mat-datepicker-toggle matSuffix (click)="campos.controls[i].reset()">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                }
                <mat-datepicker #picker></mat-datepicker>
              }
              <!-- Campo: Archivo -->
              @if (campo.tipo === TipoCampoFormulario.ARCHIVO) {
                <ngx-mat-file-input
                  [formControlName]="i"
                  [multiple]="campo.multiples || false"
                  [accept]="campo.aceptados.join(',')"
                  [valuePlaceholder]="campo.placeholder ?? ''"
                  (click)="campo.escaner && escanearDocumento$(campo, campos.controls[i], $event)"
                >
                </ngx-mat-file-input>
              }
              @if (campo.tipo === TipoCampoFormulario.ARCHIVO) {
                <button matSuffix mat-icon-button class="btn-adjuntar">
                  <mat-icon>attach_file</mat-icon>
                </button>
              }
              <!-- Campo: Opción Múltiple -->
              @if (campo.tipo === TipoCampoFormulario.OPCION_MULTIPLE) {
                <mat-select
                  [formControlName]="i"
                  [placeholder]="campo.placeholder ?? ''"
                  [multiple]="!!campo.multiple"
                >
                  @if (campo.buscador) {
                    <mat-option>
                      <ngx-mat-select-search
                        [formControl]="buscadorCampo[campo.slug]"
                        placeholderLabel="Buscar..."
                        noEntriesFoundLabel="No se encontraron opciones"
                      ></ngx-mat-select-search>
                    </mat-option>
                  }
                  @for (opcion of opcionesCampo[campo.slug] || []; track opcion) {
                    <mat-option
                      [value]="opcion.valor"
                      (onSelectionChange)="$event.source.selected && campo.opcionOut?.next(opcion)"
                    >
                      {{ opcion.nombre }}
                    </mat-option>
                  }
                </mat-select>
              }
              <!-- Campo: Autocomplete -->
              @if (campo.tipo === TipoCampoFormulario.AUTOCOMPLETE) {
                <input
                  matInput
                  type="text"
                  [formControlName]="i"
                  [placeholder]="campo.placeholder ?? ''"
                  [matAutocomplete]="auto"
                  [readonly]="campo.readonly || false"
                />
                <mat-autocomplete #auto="matAutocomplete">
                  @for (opcion of opcionesCampo[campo.slug] || []; track opcion) {
                    <mat-option
                      [value]="opcion.valor"
                      (onSelectionChange)="$event.source.selected && campo.opcionOut?.next(opcion)"
                    >
                      {{ opcion.nombre }}
                    </mat-option>
                  }
                </mat-autocomplete>
              }
              <!-- Campo: Booleano -->
              @if (campo.tipo === TipoCampoFormulario.BOOLEANO) {
                <mat-select [formControlName]="i" [placeholder]="campo.placeholder ?? ''">
                  @if (!campo.requerido) {
                    <mat-option [value]="null">-</mat-option>
                  }
                  <mat-option [value]="true">Sí</mat-option>
                  <mat-option [value]="false">No</mat-option>
                </mat-select>
              }
              <!-- Campo: Coordenadas -->
              @if (campo.tipo === TipoCampoFormulario.COORDENADAS) {
                <input hidden="true" matInput readonly style="display: none" />
                @if (campo.readonly && !campo.valor) {
                  <span style="padding: 0 1rem"> Sin coordenadas </span>
                }
                @if (campo.valor || !campo.readonly) {
                  <google-map
                    #mapa
                    [height]="campo.height || '400px'"
                    [zoom]="(campo.zoom ?? campo.valor) ? 15 : 6"
                    [class.readonly]="campo.readonly"
                    [mapId]="campo.slug"
                    [options]="CONFIGURACION_MAPA_FORMULARIO"
                    [center]="
                      campo.valor
                        ? {
                            lat: campo.valor.latitud,
                            lng: campo.valor.longitud,
                          }
                        : (campo.centro ?? CENTRO_MAPA)
                    "
                    width="100%"
                    (mapClick)="ponerMarcadorMapa(campo, $event.latLng!.toJSON())"
                  >
                    @if (campos.controls[i].value; as coords) {
                      <map-marker
                        [position]="{
                          lat: coords.latitud,
                          lng: coords.longitud,
                        }"
                      />
                    }
                    @if (campo.placeholder && !campo.readonly && !campos.controls[i].value) {
                      <p class="placeholder">
                        {{ campo.placeholder }}
                      </p>
                    }
                  </google-map>
                }
              }
            </mat-form-field>
            <!-- Error -->
            @if (!estilo?.esconderErrores && !campo.readonly && campos.controls[i]; as control) {
              <mat-error class="error">
                @if (control.invalid && formulario.touched) {
                  <span>
                    {{ obtenerErrorControl(campos.controls[i]) }}
                  </span>
                }
              </mat-error>
            }
          </div>
        </div>
      }
    </div>
  </form>
}

@if (!configuracion) {
  <div class="cargando">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
}
